// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SwitchBotLink_wrapper__1xmEN"};